import React, { ReactNode } from 'react';
import { LucideIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { IconWrapper } from './IconWrapper';

interface CTACardProps {
  title: string;
  description: string;
  buttonText: string;
  buttonLink: string;
  icon?: ReactNode;
  iconComponent?: LucideIcon;
  className?: string;
}

export const CTACard: React.FC<CTACardProps> = ({
  title,
  description,
  buttonText,
  buttonLink,
  icon,
  iconComponent: Icon,
  className = '',
}) => {
  return (
    <div className={`cta_card p-10 sm:p-12 rounded-2xl bg-blue-700 border border-blue-600 shadow-sm transition-all duration-300 text-white ${className}`}>
      <div className="flex items-center gap-3 mb-4">
        <div className="flex items-center justify-center w-11 h-11 rounded-full bg-blue-600">
          {icon ? (
            React.cloneElement(icon as React.ReactElement, { className: 'h-6 w-6 text-white' })
          ) : Icon ? (
            <Icon className="h-6 w-6 text-white" />
          ) : null}
        </div>
        <h3 className="heading-style-h2 text-xl sm:text-2xl font-normal text-blue-200 mb-0">{title}</h3>
      </div>
      <p className="text-base text-blue-100 font-normal mb-4 leading-relaxed">{description}</p>
      <CTAButton href={buttonLink} variant="white">
        {buttonText}
      </CTAButton>
    </div>
  );
};
